import { combineReducers, configureStore } from '@reduxjs/toolkit';
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import authReducer from './slices/authSlice';
import documentReducer from './slices/documentSlice';
import reportReducer from './slices/reportSlice';
import chatReducer from './slices/chatSlice';
import chatSessionsReducer from './slices/chatSessionsSlice';
import userStatisticsReducer from './slices/userStatisticsSlice';
import streamingReducer from './slices/streamingSlice';
import requestReducer from './slices/requestSlice';
import spaceReducer from './slices/spaceSlice';

const rootReducer = combineReducers({
  auth: authReducer,
  document: documentReducer,
  streaming: streamingReducer,
  report: reportReducer,
  chat: chatReducer,
  chatSessions: chatSessionsReducer,
  userStatistics: userStatisticsReducer,
  request: requestReducer,
  spaces: spaceReducer,
});

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth', 'document', 'chat', 'userStatistics', 'streaming'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        ignoredPaths: ['request.controller'],
      },
    }),
});

export const persistor = persistStore(store);
